(function () {
  'use strict';

  var PRODUCT_PATH_RE = /\/products\/([^\/?#]+)/i;

  function sameOriginUrl(raw) {
    try {
      var url = new URL(String(raw || ''), window.location.href);
      if (url.origin !== window.location.origin) return null;
      return url;
    } catch (err) {
      return null;
    }
  }

  function handleFromUrl(raw) {
    var url = sameOriginUrl(raw);
    if (!url) return '';
    var parts = url.pathname.split('/').filter(Boolean);
    var idx = parts.indexOf('products');
    if (idx < 0 || !parts[idx + 1]) return '';
    return decodeURIComponent(parts[idx + 1]).replace(/\.js$/i, '').trim();
  }

  function productHref(raw) {
    var url = sameOriginUrl(raw);
    return !!(url && PRODUCT_PATH_RE.test(url.pathname));
  }

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function firstText(root, selectors) {
    for (var i = 0; i < selectors.length; i += 1) {
      var el = root && root.querySelector ? root.querySelector(selectors[i]) : null;
      var txt = cleanText(el && el.textContent);
      if (txt) return txt;
    }
    return '';
  }

  function firstImage(root) {
    var img = root && root.querySelector ? root.querySelector('img') : null;
    if (!img) return '';
    return img.currentSrc || img.src || img.getAttribute('src') || '';
  }

  function seedFromElement(anchor) {
    if (!anchor) return {};
    return {
      title: cleanText(anchor.getAttribute('data-title')) || firstText(anchor, ['.title', '.bss-title', '.card__title', 'strong', '[data-product-title]']),
      imageUrl: anchor.getAttribute('data-image') || firstImage(anchor),
      priceText: cleanText(anchor.getAttribute('data-price')) || firstText(anchor, ['.price', '.bss-price', '[data-product-price]']),
      price: cleanText(anchor.getAttribute('data-raw-price')),
      compareAtPrice: cleanText(anchor.getAttribute('data-compare-at-price')),
      compareAtPriceText: cleanText(anchor.getAttribute('data-compare-at-price-text')),
      isOnSale: anchor.getAttribute('data-on-sale') === 'true',
      salePercent: cleanText(anchor.getAttribute('data-sale-percent'))
    };
  }

  function queueOrOpen(handle, seed) {
    handle = cleanText(handle);
    if (!handle) return false;
    seed = seed || {};

    if (window.BuzzGlobalPopup && typeof window.BuzzGlobalPopup.open === 'function') {
      window.BuzzGlobalPopup.open(handle, seed);
      return true;
    }

    window.__bzpQueue = window.__bzpQueue || [];
    window.__bzpQueue.push({ handle: handle, seed: seed });
    return true;
  }

  function getProductHandle(anchor) {
    return cleanText(anchor && (anchor.getAttribute('data-handle') || anchor.getAttribute('data-buzz-product-handle'))) ||
      handleFromUrl(anchor && (anchor.getAttribute('href') || anchor.href));
  }

  function shouldIgnoreClick(event, anchor) {
    if (!event || event.defaultPrevented || !anchor) return true;
    if (event.button && event.button !== 0) return true;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return true;
    if (anchor.hasAttribute('download')) return true;
    var target = String(anchor.getAttribute('target') || '').toLowerCase();
    if (target && target !== '_self') return true;
    var actionControl = event.target && event.target.closest ? event.target.closest('[data-vid], form[action*="/cart/add"], .bss-add[data-vid], .bsa-add[data-vid]') : null;
    return !!actionControl;
  }

  function shouldOpenAsPopup(anchor) {
    if (!anchor) return false;

    // Explicit product cards keep the Buzz popup experience.
    if (anchor.hasAttribute('data-handle') || anchor.hasAttribute('data-buzz-product-handle')) return true;

    // Search/vending/Buzz Market product areas also stay popup-based.
    if (anchor.closest && anchor.closest('.bss-store, .bm3d-app, .bm3d-stage, [data-buzz-popup-products], .buzz-popup-products')) return true;

    // Plain /products/handle links are now real product pages for SEO/direct links.
    return false;
  }

  function bindProductClicks() {
    document.addEventListener('click', function (event) {
      var anchor = event.target && event.target.closest ? event.target.closest('a[href], a[data-handle], a[data-buzz-product-handle]') : null;
      if (shouldIgnoreClick(event, anchor)) return;

      var href = anchor.getAttribute('href') || anchor.href || '';
      var handle = getProductHandle(anchor);
      if (!handle || (!productHref(href) && !anchor.hasAttribute('data-handle') && !anchor.hasAttribute('data-buzz-product-handle'))) return;

      if (!shouldOpenAsPopup(anchor)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      queueOrOpen(handle, seedFromElement(anchor));
    }, true);
  }

  function openFromUrlParams() {
    var params;
    try {
      params = new URLSearchParams(window.location.search || '');
    } catch (err) {
      return;
    }

    var handle = cleanText(params.get('bz_open') || params.get('bz_open_product'));
    if (!handle) return;

    var seed = {
      title: cleanText(params.get('bz_title')) || cleanText(params.get('q')),
      imageUrl: '',
      priceText: ''
    };

    try {
      var pendingRaw = sessionStorage.getItem('bzp_pending');
      if (pendingRaw) {
        var pending = JSON.parse(pendingRaw);
        if (pending && pending.handle === handle) sessionStorage.removeItem('bzp_pending');
      }
    } catch (err) {}

    queueOrOpen(handle, seed);

    function fillSearchInput() {
      var input = document.getElementById('searchInput');
      if (input && seed.title) input.value = seed.title;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fillSearchInput, { once: true });
    } else {
      fillSearchInput();
    }
  }

  bindProductClicks();
  openFromUrlParams();
})();
